<div *ngIf="showList" id="my-prizes" class="myprize-list mt-4" [attr.aria-label]="getTitle()">
    <div role="heading" aria-level="2" class="title-md-bold">{{getTitle()}}
        <div *ngIf="loading" alt="Loading..." class="small progress">
            <div class="prog1">
                <div class="prog2"></div>
            </div>
        </div>
    </div>
    <div *ngIf="myPrizes.length == 0" class="list-container mt-3">
        <div class="empty-list">
            <div>
                <div class="message">{{noPrizeMessage}}</div>
                <div>{{noPrizeAdditionalMessage}}</div>
            </div>
        </div>
    </div>
    <div *ngIf="myPrizes.length > 0" class="list-container mt-3">
        <div class="non-empty-list">
            <div *ngFor="let prize of myPrizes; let i = index; let isFirst = first">
                <div *ngIf="!isFirst && i < displayPrizeCount" class="prize-item-separator"></div>
                <div *ngIf="i < displayPrizeCount" class="prize-item">
                    <div class="prize-image-container">
                        <div *ngIf="getDaysRemaining(prize) > 0" class="prize-image-days-left price-xs">{{getDaysRemaining(prize)}} {{getDaysLabel(getDaysRemaining(prize))}}</div>
                        <picture>
                            <source media="(min-width: {{md}})" srcset="{{getImageUrl(prize,'desktop')}}">
                            <source media="(min-width: {{sm}})" srcset="{{getImageUrl(prize,'tablet')}}">
                            <img loading="lazy" class="prize-image" src="{{getImageUrl(prize,'mobile')}}" alt=""/>
                        </picture>
                    </div>
                    <div class="prize-text">
                        <div class="body-text-xs">{{getDisplayDate(prize) | date: 'longDate'}}</div>
                        <div [id]="'prize-card-' + prize.prizeId" class="prize-name title-sm-bold" role="heading" aria-level="3">{{prize.description}}</div>
                        <div [id]="'prize-card-body-' + prize.prizeId" class="body-text-sm">
                            <span>{{getStatusLine(prize)}}&nbsp;</span>
                            <ng-container *ngIf="this.gameType == GAMETYPES.DIVISION">
                                <a *ngIf="prize.prizeType == PRIZETYPES.B4U_OFFER" href='/mylist.html' class="link-sm">My List</a>
                                <a *ngIf="prize.prizeType == PRIZETYPES.REWARD" href='/foru/rewards.html' class="link-sm">Rewards</a>
                                <a *ngIf="prize.prizeType == PRIZETYPES.FRESH_PASS" href='/freshpass/manage/subscribe.html' class="link-sm">Sign up</a>
                            </ng-container>
                        </div>
                    </div>
                    <div class="prize-link" *ngIf="this.gameType == GAMETYPES.EPISODIC && getPrizeType(prize)">
                        <a *ngIf="prize.prizeType == PRIZETYPES.SWEEPSTAKES" href="#" (click)="showSweepstakesModal(prize)" role="link" class="link-sm prize-link-anchor" [attr.aria-label]="'View sweepstakes notification'" [attr.aria-describedby]="'prize-card-' + prize.prizeId + ' prize-card-body-' + prize.prizeId">View <span class="view-svg-icon"></span></a>
                        <a *ngIf="getHrefToRedirect(prize) != ''" href='{{getHrefToRedirect(prize)}}' role="link" class="link-sm prize-link-anchor" [attr.aria-label]="getViewAriaLabel(prize)" [attr.aria-describedby]="'prize-card-' + prize.prizeId + ' prize-card-body-' + prize.prizeId">View <span class="view-svg-icon"></span></a>
                    </div>
                </div>
            </div> 
        </div>
        <div class="mt-4 mb-4 load-more__container" *ngIf="displayPrizeCount < myPrizes.length">
            <button class="btn btn-xl btn-secondary" tabindex="0" role="button" (click)="showMorePrizes()">Show more <span class="sr-only">{{getTitle()}}</span></button>
        </div>
    </div>
</div>